<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="d-flex with-media">
          <div class="p-2 w-70">
            <div class="media">
              <img src="/static/img/test@2x.png"/>
              <div class="media-body">
                <h1>{{examInfo.title}}</h1>
                <div>
                  <span class="gray">유형</span> {{examInfo.exam_type_name}}
                    ·  <span class="gray">응시 인원 </span> <span class="number">{{classUserData.length}}</span>
                    ·  <span class="gray">공개 여부</span> <strong>{{examInfo.stat_name}}</strong>
                    ·  <span class="gray">카테고리</span> {{examInfo.cate_path}}
                    ·  <span class="gray">알림톡</span> {{examInfo.send_msg_yn === 'Y' ? '전송' : '미전송'}}
                    <template v-if="examInfo.online_yn === 'Y'">·  <el-tag size="mini">온라인 시험</el-tag></template>
                    <template v-if="examInfo.close_yn === 'Y'">·  <el-tag type="warning" size="mini">종료 미사용</el-tag></template>
                   <br />
                   <span class="gray">생성일</span> {{this.formatterDate(examInfo.reg_dt)}}
                   <template v-if="examInfo.open_dt !== ''">·  <span class="gray">공개일</span> {{this.formatterDate(examInfo.open_dt)}}</template>
                   <template v-if="examInfo.close_dt !== '' && examInfo.close_dt !== '-'">·  <span class="gray">종료일</span> {{this.formatterDate(examInfo.close_dt)}}</template>
                </div>
              </div>
            </div>
          </div>
          <div class="p-2 ml-auto button-group button-exam">
            <button type="button" class="btn btn-info" @click="handleCommand('paper')">시험지<br/>보기</button>
            <!-- <button type="button" class="btn btn-secondary" @click="handleCommand('download')" v-if="examInfo.download_url_pdf">시험지<br/>저장</button> -->
            <button type="button" class="btn btn-danger" @click="handleCommand('delete')" v-if="examInfo.stat === 'N'">시험<br/>삭제</button>
            <button type="button" class="btn btn-secondary" @click="handleCommand('online')" v-if="examInfo.stat === 'N' && examInfo.online_yn === 'Y' && examInfo.online_open_yn === 'N'">온라인<br/>응시</button>
            <button type="button" class="btn btn-warning" @click="handleCommand('offline')" v-if="examInfo.stat === 'N' && examInfo.online_yn === 'Y' && examInfo.online_open_yn === 'Y'">온라인<br/>응시취소</button>
            <button type="button" class="btn mint" @click="handleCommand('open')" v-if="classUserData.length > 0 && examInfo.stat === 'N'">시험<br/>공개</button>
            <button type="button" class="btn btn-warning" @click="handleCommand('cancel')" v-if="isExamOpenCancel">공개<br/>취소</button>
            <button type="button" class="btn btn-primary" @click="handleCommand('close')" v-if="isExamClose">시험<br/>종료</button>
            <button type="button" class="btn" @click="handleCommand('refresh')">새로<br/>고침</button>
          </div>
        </div>
      </div>
    </div>

    <div class="card second-card">
      <div class="card-body">
        <div class="d-flex">
          <div class="p-2">
            <h2>응시 인원 <span class="number mint">{{classUserData.length}}</span></h2>
          </div>
          <div class="ml-auto p-2">
            <button v-if="btnAddClassUser" type="button" class="btn mint" @click="addClassUser">+ 응시 인원 등록</button>
          </div>
        </div>
      </div>
      <stone-data-table
        class="no-left-margin small-td"
        :loading="searchLoading"
        :columns="classUserColumns"
        :data="classUserData"
        :table-props="tableProps"
        :page-size="emptyPageSize"
        :pagination-props="emptyPaginationProps"
        @row-click="classUserRowClickHandler">
      </stone-data-table>
    </div>

    <!-- 응시 인원 모달 -->
    <el-dialog width="70%" title="응시인원 등록" :visible.sync="dialogTableVisible" :before-close="diallogClosedHandler" append-to-body>
      <el-row>
        <el-col :span="11">
          <h5>
            전체 인원 <strong><span class="number mint">{{classUserLeftData.length}}</span></strong>
          </h5>
          <el-input v-model="classUserLeftFilters[0].value" placeholder="클래스 / 이름 / 전화번호" prefix-icon="el-icon-search" class="user-filter"></el-input>
          <stone-data-table
            ref="classUserLeftTable"
            class="no-left-margin small-td"
            table-ref="classUserLeftTable"
            :loading="searchLoading"
            :columns="classUserPopupColumns"
            :data="classUserLeftData"
            :filters="classUserLeftFilters"
            :table-props="classUserProps"
            :page-size="emptyPageSize"
            :pagination-props="emptyPaginationProps"
            @selection-change="handleSelectionChangeLeft"
            @row-click="classUserLefteRowClickHandler">
          </stone-data-table>
          <!-- <div class="text-right mt-3">
            <button type="button" class="btn white" @click="handleSelectionToggle('classUserLeftTable', false)">전체선택해제</button>
            <button type="button" class="btn white text-black" @click="handleSelectionToggle('classUserLeftTable', true)">전체선택</button>
          </div> -->
        </el-col>
        <el-col :span="2">
          <div class="align-middle member-transfer">
            <el-button icon="fas fa-arrow-right"  @click="moveRight" class="btn" :disabled="classUserLeftSelection.length === 0"></el-button>
            <el-button icon="fas fa-arrow-left"  @click="moveLeft" class="btn" :disabled="classUserRightSelection.length === 0"></el-button>
          </div>
        </el-col>
        <el-col :span="11">
          <h5>
            선택된 응시 인원 <strong><span class="number mint">{{classUserRightData.length}}</span></strong>
          </h5>
          <el-input v-model="classUserRightFilters[0].value" placeholder="클래스 / 이름 / 전화번호" prefix-icon="el-icon-search" class="user-filter"></el-input>
          <stone-data-table
            ref="classUserRightTable"
            class="no-left-margin small-td"
            table-ref="classUserRightTable"
            :loading="searchLoading"
            :columns="classUserPopupRightColumns"
            :data="classUserRightData"
            :filters="classUserRightFilters"
            :table-props="classUserProps"
            :page-size="emptyPageSize"
            :pagination-props="emptyPaginationProps"
            @selection-change="handleSelectionChangeRight"
            @row-click="classUserRighteRowClickHandler">
          </stone-data-table>
          <!-- <div class="text-right mt-3">
            <button type="button" class="btn white" @click="handleSelectionToggle('classUserRightTable', false)">전체선택해제</button>
            <button type="button" class="btn white text-black" @click="handleSelectionToggle('classUserRightTable', true)">전체선택</button>
          </div> -->
        </el-col>
      </el-row>
      <div style="margin-top: 20px; text-align: right;">
        <el-button @click="diallogClosedHandler">닫기</el-button>
        <el-button type="primary" @click="registerClassUser">완료</el-button>
      </div>
    </el-dialog>

    <!-- 시험 공개 모달 -->
    <el-dialog width="450px" title="" :visible.sync="dialogExamOpenVisible" :before-close="diallogExamOpenClosedHandler" append-to-body>
      <div>
        <h4>해당 시험을 공개하시겠습니까?</h4>
      </div>
      <div>
        <el-radio-group v-model="examInfo.send_msg_yn" class="stone-radio-btton exam-open-send-msg">
          <el-radio-button label="Y">알림톡 전송</el-radio-button>
          <el-radio-button label="N">알림톡 미전송</el-radio-button>
        </el-radio-group>
      </div>
      <div style="margin-top: 20px; text-align: right;">
        <el-button @click="diallogExamOpenClosedHandler">취소</el-button>
        <el-button type="primary" @click="confirmOpenExam">확인</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import common from '@/modules/common'

export default {
  name: 'M050103',
  mixins: [common.mixins],
  data () {
    return {
      dialogTableVisible: false,
      dialogExamOpenVisible: false,
      btnAddClassUser: false,
      examInfo: {
        exam_seq: 0,
        exam_paper_seq: 0,
        exam_paper_title: '',
        cate_path: '',
        cate_code: '',
        curriculum_seq: '',
        curriculum_name: '',
        quiz_cnt: '',
        exam_type: '',
        exam_type_name: '',
        title: '',
        content: '',
        reg_dt: '',
        open_dt: '',
        close_dt: '',
        exam_term: '',
        stat_name: '',
        stat: '',
        exam_user_cnt: 0,
        exam_class_cnt: 0,
        exam_entry_cnt: 0,
        use_yn: 'Y',
        file_name_pdf: '',
        download_url_pdf: '',
        exam_user: [],
        send_msg_yn: '',
        online_yn: 'N',
        online_open_yn: 'N',
        close_yn: 'N'
      },
      tableProps: {height: this.getScreenHeight(31), rowClassName: this.membershipRowClassName},
      classUserData: [],
      classUserColumns: [
        // {label: '', prop: 'chk', align: 'center', type: 'selection'},
        {label: 'No', align: 'center', type: 'index'},
        {label: '클래스명', prop: 'class_name', align: 'left', width: 200},
        {label: '이름', prop: 'class_user_name', align: 'left', width: 100},
        {label: '아이디', prop: 'class_user_id', align: 'left', width: 100},
        {label: '응시여부', prop: 'stat_name', align: 'center', width: 80},
        {label: '답안제출일시', prop: 'submit_date', align: 'center', width: 120},
        {label: '점수', prop: 'exam_score', align: 'right', width: 80},
        {label: '백분위점수', prop: 'exam_score_100', align: 'right', width: 80, formatter: this.columnFormatterPrecision},
        {label: '알림톡', prop: 'o_kakao_stat_name', align: 'center', width: 80}
      ],
      classUserProps: {height: 500, rowClassName: this.examUserRowClassName},
      classUserPopupColumns: [
        {label: '', prop: 'chk', align: 'center', type: 'selection'},
        // {label: 'No', align: 'center', type: 'index', width: 40},
        {label: '클래스명', prop: 'class_name', align: 'left', width: 150},
        {label: '이름', prop: 'class_user_name', align: 'left', width: 100},
        {label: '전화번호', prop: 'phone', align: 'left', width: 100, formatter: this.columnFormatterPhone}
      ],
      classUserPopupRightColumns: [
        {label: '', prop: 'chk', align: 'center', type: 'selection', selectable: this.classUserRightSelecabletHandler},
        // {label: 'No', align: 'center', type: 'index', width: 40},
        {label: '클래스명', prop: 'class_name', align: 'left', width: 150},
        {label: '이름', prop: 'class_user_name', align: 'left', width: 100},
        {label: '전화번호', prop: 'phone', align: 'left', width: 100, formatter: this.columnFormatterPhone},
        {label: '응시여부', prop: 'stat_name', align: 'center', width: 80}
      ],
      classUserLeftData: [],
      classUserRightData: [],
      classUserLeftSelection: [],
      classUserRightSelection: [],
      classUserLeftFilters: [
        {prop: ['class_name', 'class_user_name', 'phone'], value: ''}
      ],
      classUserRightFilters: [
        {prop: ['class_name', 'class_user_name', 'phone'], value: ''}
      ],
      kakaoMsg: {
        success_cnt: 0,
        failed_cnt: 0
      },
      sendMsgYnOld: ''
    }
  },
  created () {
    const examSeq = this.$route.params.exam_seq
    if (examSeq && examSeq !== 0) {
      this.loadInfo(examSeq)
    } else {
      this.$router.push({name: 'M050101'})
    }
  },
  computed: {
    isExamOpenCancel: function () {
      // 시험 상태가 공개이고, 응시한 수강생이 없을 경우에만 시험 공개 취소 버튼을 보여준다.
      const stat = this.classUserData.find(x => x.stat === 'S')
      return this.examInfo.stat === 'O' && !stat
    },
    isExamClose: function () {
      // 시험 상태가 공개인 경우에만
      const stat = this.classUserData.find(x => x.stat === 'S')
      return this.examInfo.stat === 'O' && stat
    }
  },
  methods: {
    // 시험 정보 조회
    loadInfo (examSeq) {
      this.loadStoneDataTable('/exam/load/' + examSeq, null, false)
        .then(response => {
          const result = response.data
          // console.log('result : ', result)
          Object.keys(this.examInfo).forEach(key => {
            this.examInfo[key] = this.isEmpty(result.exam[key]) ? '' : result.exam[key]
          })
          // console.log(this.examInfo)
          this.classUserData = result.exam_user
          // 알림톡 전송 성공
          this.kakaoMsg.success_cnt = this.classUserData.filter(x => x.o_kakao_stat === 'H' || x.o_kakao_stat === 'J').length
          // 알림톡 전송 실패
          this.kakaoMsg.failed_cnt = this.classUserData.filter(x => x.o_kakao_stat === 'D' || x.o_kakao_stat === 'I').length
          // 응시 인원 등록 버튼 활성화 조건 (오답노트가 아니고, 시험 종료가 아닐 경우)
          this.btnAddClassUser = this.examInfo.exam_type !== 'NOTE' && this.examInfo.stat !== 'C'
        })
    },
    noticeRowClickHandler (event, row) {
    },
    classUserRowClickHandler (event, row) {
    },
    // 응시 인원 추가
    addClassUser () {
      this.retreiveClassUser(true)
    },
    // 현재 클래스에 속하지 않은 수강생 조회
    retreiveClassUserAdd () {
      this.loadStoneDataTable('/exam/user/class/not/' + this.examInfo.exam_seq, {})
        .then(response => {
          this.classUserLeftData = response.data
        })
        .catch(() => {
          this.classUserLeftData = []
        })
    },
    // 우측으로 선택된 수강생 이동
    moveRight () {
      this.classUserRightData = this.classUserRightData.concat(this.classUserLeftSelection)
      this.classUserLeftData = this.arraySplice(this.classUserLeftSelection, this.classUserLeftData)
      this.classUserLeftSelection = []
      this.classUserLeftFilters[0].value = ''
    },
    // 좌측으로 선택된 수강생 이동
    moveLeft () {
      this.classUserLeftData = this.classUserLeftData.concat(this.classUserRightSelection)
      this.classUserRightData = this.arraySplice(this.classUserRightSelection, this.classUserRightData)
      this.classUserRightSelection = []
      this.classUserRightFilters[0].value = ''
    },
    arraySplice (selection, target) {
      const deleteIndex = []
      selection.map(item => {
        deleteIndex.push(target.findIndex(e => e === item))
      })
      // 정렬 순서가 선택된 순서에 따라 틀려지므로, 마지막 인덱스부터 삭제 할 수 있도록 정렬(DESC)한다.
      deleteIndex.sort((a, b) => b - a).map(idx => {
        target.splice(idx, 1)
      })
      return target
    },
    handleSelectionChangeLeft (value) {
      this.classUserLeftSelection = value
    },
    handleSelectionChangeRight (value) {
      this.classUserRightSelection = value
    },
    // 응시 인원 등록
    registerClassUser () {
      if (this.classUserRightData.length === 0) {
        this.$message.warning('등록할 클래스 인원이 없습니다.')
        return
      }
      this.examInfo.exam_user = this.classUserRightData
      // console.log(this.examInfo)
      this.$nextTick(() => {
        common.axios.post('/exam/user', this.examInfo)
          .then(response => {
            if (response.data.status === 1) {
              this.$message('시험 응시 인원을 등록하였습니다.')
              this.dialogTableVisible = false
              this.classUserLeftData = []
              this.classUserRightData = []
              this.examInfo.exam_user = []
              this.retreiveClassUser()
            }
          })
      })
    },
    // 현재 클래스 등록 인원 조회
    retreiveClassUser (isOpen = false) {
      common.axios.get('/exam/user/in/' + this.examInfo.exam_seq)
        .then(response => {
          this.classUserData = response.data
          if (isOpen) {
            this.dialogTableVisible = true
            this.classUserRightData = [].slice.call(this.classUserData)
            this.retreiveClassUserAdd()
          }
        })
    },
    openExam () {
      if (this.classUserData.length === 0) {
        this.$message.warning('시험 응시인원이 없습니다.')
        return
      }
      let examUserCount = 0
      this.classUserData.forEach(user => {
        if (user.user_use_yn === 'Y') {
          examUserCount++
        }
      })
      if (examUserCount === 0) {
        this.$message.warning('시험 응시인원이 없습니다.')
        return
      }
      this.sendMsgYnOld = this.examInfo.send_msg_yn
      this.dialogExamOpenVisible = true
      /*
      this.$confirm('해당 시험을 공개하시겠습니까?', '', {})
        .then(() => {
          common.axios.put('/exam/open', {exam_seq: this.examInfo.exam_seq})
            .then(response => {
              const result = response.data
              if (result.status === 1) {
                this.$message('시험이 공개되었습니다.')
                this.loadInfo(this.examInfo.exam_seq)
                // this.examInfo.stat = 'O'
                // this.examInfo.stat_name = '공개'
                // this.btnAddClassUser = false
              }
            })
        }).catch(() => {})
      */
    },
    confirmOpenExam () {
      common.axios.put('/exam/open', {exam_seq: this.examInfo.exam_seq, send_msg_yn: this.examInfo.send_msg_yn})
        .then(response => {
          const result = response.data
          if (result.status === 1) {
            this.$message('시험이 공개되었습니다.')
          } else {
            this.$message.warning(result.message)
          }
          this.loadInfo(this.examInfo.exam_seq)
          this.dialogExamOpenVisible = false
        }).catch(() => {})
    },
    closeExam () {
      this.$confirm('해당 시험을 종료하시겠습니까?', '', {dangerouslyUseHTMLString: true})
        .then(() => {
          common.axios.put('/exam/close', {exam_seq: this.examInfo.exam_seq})
            .then(response => {
              const result = response.data
              if (result.status === 1) {
                this.$message('시험이 종료되었습니다.')
                this.examInfo.stat = 'C'
                this.examInfo.stat_name = '종료'
                this.btnAddClassUser = false
              } else {
                this.$alert(this.replaceCarriageReturnToBr(result.message), '', {dangerouslyUseHTMLString: true})
              }
            })
        }).catch(() => {})
    },
    cancelExamOpen () {
      this.$confirm('해당 시험 공개를 취소하시겠습니까?', '', {})
        .then(() => {
          common.axios.put('/exam/cancel', {exam_seq: this.examInfo.exam_seq})
            .then(response => {
              const result = response.data
              if (result.status === 1) {
                this.$message('시험 공개가 취소되었습니다.')
                this.loadInfo(this.examInfo.exam_seq)
                // this.examInfo.stat = 'N'
                // this.examInfo.stat_name = '미공개'
                // this.btnAddClassUser = true
              } else {
                this.$alert(result.message)
                // this.$message.warning(result.message)
              }
            })
        }).catch(() => {})
    },
    tableRowClassName ({row, rowIndex}) {
      return row.stat === 'S' ? 'success-row' : ''
    },
    handleSelectionToggle (ref, isToggle) {
      if (ref === 'classUserLeftTable') {
        this.handleTableSelectionToggleAll(ref, this.classUserLeftData, isToggle)
      } else {
        this.handleTableSelectionToggleAll(ref, this.classUserRightData, isToggle)
      }
    },
    deleteExam () {
      this.$confirm('해당 시험을 삭제하시겠습니까?', '', {
      }).then(() => {
        common.axios.delete('/exam', {data: {exam_seq: this.examInfo.exam_seq}})
          .then(response => {
            if (response.data.status === 1) {
              this.$message('시험이 삭제되었습니다.')
              setTimeout(() => {
                this.$router.push({name: 'M050101'})
              }, 1000)
            } else {
              this.$message.warning(response.data.message)
            }
          })
          .catch(() => {
            this.$message.error('삭제 실패하였습니다. 관리자에게 문의하세요')
          })
      }).catch(() => {})
    },
    handleCommand (command) {
      if (command === 'paper') {
        // 시험지 상세 화면으로 이동
        this.$router.push({name: 'M040102', params: {exam_paper_seq: this.examInfo.exam_paper_seq}})
      } else if (command === 'download') {
        // 시험지 파일 다운로드
        this.downloadFile(this.examInfo.download_url_pdf)
      } else if (command === 'delete') {
        // 시험 삭제
        this.deleteExam()
      } else if (command === 'open') {
        // 시험 공개
        this.openExam()
      } else if (command === 'cancel') {
        // 시험 공개 취소
        this.cancelExamOpen()
      } else if (command === 'close') {
        // 시험 종료
        this.closeExam()
      } else if (command === 'refresh') {
        // 새로 고침
        this.loadInfo(this.examInfo.exam_seq)
      } else if (command === 'online') {
        // 온라인 공개
        this.openOnlineExam()
      } else if (command === 'offline') {
        // 온라인 공개 취소
        this.cancelOnlineExam()
      }
    },
    classUserLefteRowClickHandler (row) {
      this.handleTableSelectionToggle('classUserLeftTable', row)
    },
    classUserRighteRowClickHandler (row) {
      // 시험 상태가 미응시인 경우에만 체크박스에 대해 토글 이벤트를 실행한다.
      if (row.stat !== 'S') {
        this.handleTableSelectionToggle('classUserRightTable', row)
      }
    },
    classUserRightSelecabletHandler (row, index) {
      // 시험 상태가 응시인 경우에는 체크박스를 비활성화 한다.
      return row.stat !== 'S'
    },
    diallogClosedHandler () {
      this.dialogTableVisible = false
      this.classUserLeftFilters[0].value = ''
      this.classUserRightFilters[0].value = ''
    },
    diallogExamOpenClosedHandler () {
      this.dialogExamOpenVisible = false
      if (this.sendMsgYnOld !== this.examInfo.send_msg_yn) {
        this.examInfo.send_msg_yn = this.sendMsgYnOld
      }
    },
    openOnlineExam () {
      this.$confirm('해당 시험을 온라인 응시가 가능하도록 공개하시겠습니까?', '', {})
        .then(() => {
          common.axios.put('/exam/online/open', {exam_seq: this.examInfo.exam_seq})
            .then(response => {
              const result = response.data
              if (result.status === 1) {
                this.$message('온라인 시험 응시가 공개 되었습니다.')
                this.loadInfo(this.examInfo.exam_seq)
              }
            })
        }).catch(() => {})
    },
    cancelOnlineExam () {
      this.$confirm('해당 시험을 온라인 응시취소 하시겠습니까?', '', {})
        .then(() => {
          common.axios.put('/exam/online/close', {exam_seq: this.examInfo.exam_seq})
            .then(response => {
              const result = response.data
              if (result.status === 1) {
                this.$message('온라인 시험 응시가 취소 되었습니다.')
                this.loadInfo(this.examInfo.exam_seq)
              }
            })
        }).catch(() => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/M050103.vue